module.exports = __webpack_public_path__ + "img/trademarkingNumberImg.ebe52ee5.png";